<div>
  @if (msg) {
    <div>
      <span class="alert alert-danger">{{ msg }}</span>
    </div>
  }
  <div class="form-group row">
    <div class="col-6">
      <input list="browsers" type="text" class="form-control" name="browser" [(ngModel)]="newTag" />
      <datalist id="browsers">
        @for (tag of tagList; track tag) {
          <option>{{ tag }}</option>
        }
      </datalist>
    </div>
    <div class="col-4">
      <p-button size="small" severity="primary" (onClick)="addTag()" label="Add"></p-button>
    </div>
  </div>
  <div class="row">
    @for (tag of tags; track tag) {
      <span class="tag label label-primary">{{ tag }} <small class="oi oi-delete" title="remove" (click)="deleteTag(tag)"></small></span>
    }
  </div>

  <p-button size="small" severity="primary" (onClick)="updateTags()" label="Update"></p-button>
</div>
